// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bscdown2{background-color:rgba(6,30,93,.5);box-sizing:border-box}#bscdown2,#bscdown2 .box{position:relative;width:100%;height:100%}#bscdown2 .box{display:block}", ""]);
// Exports
module.exports = exports;
